
import * as $type from '@/utils/type';
// App WebView 登录逻辑逻辑处理
export const getAppAuth = (next) => {
  /* eslint-disable no-undef */
  if ($type.isType(ms, 'Object')) {
    ms.config({
      debug: true, // 开启调试模式, 在控制台打印信息。
      dev: true // 因为目前还没有客户端调试工具，所以在本地开发的时候，开启 dev 模式接口会返回默认的开发信息
    });
    ms.ready(() => {
      /* eslint-disable no-undef */
      ms.auth({
        isNeedLogin: true, // 是否需要登录，如果 auth 获取失败的时候会让用户去登录， 默认为 true
        success (auth) { // 获取 auth 之后的成功回调
          try {
            window.localStorage.setItem('auth', auth);
            next();
          } catch (err) {
            throw err;
          }
        }
      });
    });
  } else {
    console.error('MS-JSSDK初始化失败');
  }
};
// app 分享
export const setAppShare = ({ title, link, imgUrl, desc }) => {
  /* eslint-disable no-undef */
  if ($type.isType(ms, 'Object')) {
    ms.config({
      debug: true, // 开启调试模式, 在控制台打印信息。
      dev: true // 因为目前还没有客户端调试工具，所以在本地开发的时候，开启 dev 模式接口会返回默认的开发信息
    });
    ms.ready(() => {
      /* eslint-disable no-undef */
      ms.share({
        title, // 分享标题
        link, // 分享链接
        imgUrl, // 分享图标
        desc // 分享描述 这个只有在转发给好友才会出现
      });
    });
  } else {
    console.error('MS-JSSDK初始化失败');
  }
};

export const clickFinishStudentInfo = (data) => {
  /* eslint-disable no-undef */
  if ($type.isType(ms, 'Object')) {
    ms.config({
      debug: true, // 开启调试模式, 在控制台打印信息。
      dev: true // 因为目前还没有客户端调试工具，所以在本地开发的时候，开启 dev 模式接口会返回默认的开发信息
    });
    ms.ready(() => {
      /* eslint-disable no-undef */
      ms.extend('clickFinishStudentInfo', false);
      ms.clickFinishStudentInfo({
        data, // 1: finish 2: empty
        success () {
          console.log('success');
        },
        fail () {
          console.log('fail');
        }
      });
    });
  } else {
    console.error('MS-JSSDK初始化失败');
  }
};

export const isAndroidOrIOS = () => {
  let ua = navigator.userAgent.toLowerCase();
  let str = 'android';
  if (/iphone|ipad|ipod/.test(ua)) {
    str = 'IOS';
  };
  return str;
};

export const isApp = () => {
  const ua = navigator.userAgent;
  return /meishakeji/i.test(ua);
};
